import { useTranslation } from 'react-i18next';

import testingConstants from 'utils/testingConstants';

import ApiKeysStatePanel from './ApiKeysStatePanel';

const ApiKeysDisabled = () => {
  const { t } = useTranslation();

  return (
    <ApiKeysStatePanel
      title={t('workspaces_settings.api_keys.disabled.title')}
      description={t('workspaces_settings.api_keys.disabled.body')}
      dataTestId={testingConstants.apiKeysDisabled}
    />
  );
};

export default ApiKeysDisabled;
